export const ANALYTICS_EVENTS = {
  APP_SESSION_START: 'app_session_start',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  CLAIMS_REFRESH_FORCED: 'claims_refresh_forced',
  GENERAL_ASSEMBLIES_LOADED: 'general_assemblies_loaded',
  COOWNER_NO_AG_VISIBLE: 'coowner_no_ag_visible',
  WEBRTC_CONNECTED: 'webrtc_connected',
  WEBRTC_ERROR: 'webrtc_error',
  SCREENSHARE_START: 'screenshare_start',
  SCREENSHARE_SUCCESS: 'screenshare_success',
  SCREENSHARE_ERROR: 'screenshare_error',
  MIC_PUBLISH_START: 'mic_publish_start',
  MIC_PUBLISH_SUCCESS: 'mic_publish_success',
  MIC_PUBLISH_ERROR: 'mic_publish_error',
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
